import { getOffsetRect } from "../../../lib/utils/styling";
import DropHint from './base';
import { genNbsp } from "../../../lib/designer/utils/generatorNbsp";
const HINT_SIZE = 18;
// 小于一定面积缩减文本提示量
const ShortHintAreaLevel = {
  ignoreAll: 1500,
  ignoreAllName: 2000,
  ignoreId: 4000
};
export default class InsertionDropHint extends DropHint {
  constructor() {
    super(...arguments);
    this.hintClassName = '';
  }
  getRect() {
    var _this$renderer$getRef;
    const {
      compPath,
      after
    } = this.config;
    const {
      slotDirection
    } = this.ownerSlot;
    const refElement = (_this$renderer$getRef = this.renderer.getRefByPath(compPath)) === null || _this$renderer$getRef === void 0 ? void 0 : _this$renderer$getRef.$el;
    if (!refElement) return null;
    const {
      x: x0,
      y: y0,
      width: w0,
      height: h0
    } = getOffsetRect(refElement, this.ownerSlot.slotContainerElement);
    const horizontal = slotDirection.includes('row');
    const reversed = slotDirection.includes('reversed');
    if (horizontal) {
      return {
        x: x0 + (after !== reversed ? w0 : -HINT_SIZE),
        y: y0,
        width: HINT_SIZE,
        height: h0
      };
    }
    return {
      x: x0,
      y: y0 + (after !== reversed ? h0 : -HINT_SIZE),
      width: w0,
      height: HINT_SIZE
    };
  }
  getDescription() {
    // 简单判断一下文字量的溢出情况 适当缩短提示
    const shortHint = {
      ignoreId: false,
      ignoreAllName: false,
      ignoreAll: false
    };
    const area = this.getAreaSize();
    Object.entries(ShortHintAreaLevel).forEach(([key, value]) => {
      if (area < value) {
        shortHint[key] = true;
      }
    });
    const rect = this.getRect();
    if (rect) {
      const {
        height,
        width
      } = rect;
      if (height > width) {
        // 纵向的 就不显示英文名字了 不可能放得下
        shortHint.ignoreId = true;
      }
    }
    if (shortHint.ignoreAll) {
      return genNbsp(6);
    }
    const compName = this.designer.uc.getLayoutName(this.designer.getCompAtPath(this.config.compPath), {
      omitId: shortHint.ignoreId
    });
    return `放到 ${shortHint.ignoreAllName ? '' : compName} ${this.config.after ? '后面' : '前面'}`;
  }
  getRelatedCompPath() {
    return this.config.compPath;
  }
  async execute() {
    const {
      designer,
      config
    } = this;
    const toRemoveCompPath = this.editZoneState.currentDraggingCompPath;
    let insertPoint = config.compPath;
    if (config.after) insertPoint = insertPoint.replace(/\/(-?\d+)$/, (_, n) => `/${+n + 1}`);
    // 为了避免 immutable 的奇怪事情，如果是 move 的话，需要使用原来 immutable 的那个 Layout 引用
    const layout = toRemoveCompPath ? designer.getCompAtPath(toRemoveCompPath) : designer.dragSource.layout;
    const newCompPath = await designer.spliceComp(toRemoveCompPath, insertPoint, layout);
    designer.compPath = newCompPath || '';
  }
}
//# sourceMappingURL=InsertionDropHint.js.map
